import { openDB } from 'idb';

const DB_NAME = 'dinner-league-offline';
const DB_VERSION = 5;

const dbPromise = openDB(DB_NAME, DB_VERSION, {
  upgrade(db) {
    if (!db.objectStoreNames.contains('recipes')) {
      db.createObjectStore('recipes', { keyPath: 'id' });
    }
    if (!db.objectStoreNames.contains('family_members')) {
      db.createObjectStore('family_members', { keyPath: 'id' });
    }

    if (!db.objectStoreNames.contains('preference_swipes')) {
      const swipeStore = db.createObjectStore('preference_swipes', { keyPath: 'id' });
      swipeStore.createIndex('member_id', 'member_id');
    }

    if (!db.objectStoreNames.contains('meal_plans')) {
      const planStore = db.createObjectStore('meal_plans', { keyPath: 'id' });
      planStore.createIndex('household_id', 'household_id');
    }

    if (!db.objectStoreNames.contains('meal_feedback')) {
      const feedbackStore = db.createObjectStore('meal_feedback', { keyPath: 'id' });
      feedbackStore.createIndex('meal_plan_id', 'meal_plan_id');
    }

    // Gamification (streaks/badges/challenges) was removed; stores from v4
    // clients are left in place (harmless) rather than explicitly deleted.
  },
});

function makeStore(storeName) {
  return {
    async getAll() {
      const db = await dbPromise;
      return db.getAll(storeName);
    },
    async get(id) {
      const db = await dbPromise;
      return db.get(storeName, id);
    },
    async put(item) {
      const db = await dbPromise;
      return db.put(storeName, item);
    },
    async putAll(items) {
      const db = await dbPromise;
      const tx = db.transaction(storeName, 'readwrite');
      for (const item of items) {
        tx.store.put(item);
      }
      await tx.done;
    },
    async clear() {
      const db = await dbPromise;
      return db.clear(storeName);
    },
    async getAllByIndex(indexName, value) {
      const db = await dbPromise;
      return db.getAllFromIndex(storeName, indexName, value);
    },
  };
}

export const offlineStore = {
  recipes: makeStore('recipes'),
  familyMembers: makeStore('family_members'),
  swipes: makeStore('preference_swipes'),
  mealPlans: makeStore('meal_plans'),
  feedback: makeStore('meal_feedback'),
};
